<template>
  <div class="weixinPay">
    <div v-if="!paySuccess">
      <el-form :model="weixinPayForm" :rules="rulesForm" ref="weixinPayForm" label-width="0" class="weixinPayForm" v-show="!qrShow">
        <div style="margin-top: 20px">
          <p class="chooseAmount">{{pc_lang.Select_the_top_up_amount}}</p>
            <el-radio-group v-model="weixinPayForm.amount" size="medium">
              <el-radio-button label="1000"></el-radio-button>
              <el-radio-button label="500"></el-radio-button>
              <el-radio-button label="200"></el-radio-button>
              <el-radio-button label="100"></el-radio-button>
            </el-radio-group>
          </div>
        <el-form-item prop="amount">
          <p>{{pc_lang.Or_enter_the_amount_manually}}</p>
          <el-input v-model="weixinPayForm.amount" prefix-icon="el-icon-money" autocomplete="off" :placeholder="pc_lang.Please_enter_the_amount" size="medium"></el-input>
        </el-form-item>
        <p class="huilv">
          <el-button type="primary" size="medium" @click="regForm('weixinPayForm')">{{pc_lang.Top_up}}</el-button>
          <span>
            {{pc_lang.WeChat_processing_fee}}
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content" class="huilvListWrap">
                <template v-if="currencyAct['huilvList']['weixin']">
                  <p class="title">每笔收取手续费<span>（{{ currencyAct['currency_short'] }}）</span></p>
                  <table>
                    <tr v-for="item in currencyAct['huilvList']['weixin']" :key="item.id">
                      <td> {{ item.startFee }}</td>
                      <td> <= </td>
                      <td>{{ item.endFee }}</td>
                      <td> : {{ item.serviceCharge < 1 ? `${item.serviceCharge}%` : `${currencyAct['currency_mark']} ${item.serviceCharge}` }}</td>
                    </tr>
                  </table>
                </template>
                <template v-else>
                  暂无配置，请询问客服，谢谢！
                </template>
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
        </p>
      </el-form>
      <div class="qrWrap weixinQrWrap" v-show="qrShow">
        <h3 v-show="!!tradeRate">{{ pc_lang.Amount_to_be_paid }}: <span><abbr>¥</abbr> {{ tradeRate || Number(weixinPayForm['amount']).toFixed(2) }}</span></h3>
        <div class="items">
          <div class="left">
            <div class="top">
              <img :src="qrCodeUrl" alt="">
            </div>
            <div class="bottom">
              <i class="iconfont icon-saoyisao"></i>
              <div>
                <p>{{pc_lang.Please_scan_using_WeChat}}</p>
                <p>{{pc_lang.Scan_QR_code_to_pay}}</p>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="/image/weixinPay_1.jpg" alt="">
          </div>
        </div>
      </div>
    </div>

    <!-- 充值完成 -->
    <div v-if="paySuccess">
      <Finish
      :mainTitle="pc_lang.top_up_successful"
      :descWord="pc_lang.Check_the_top_up_status_in_the_transaction_history"
      :routeA="'/riches'"
      :routeWordA="pc_lang.My_Credit"
      :routeB="'fresh'"
      :routeWordB="pc_lang.Next_top_up"
      :btnBool="true"
      :countBool="false"
      ></Finish>
    </div>

  </div>
</template>

<script>
import Finish from '@/components/ui/Finish'
import * as RegExp from '@/utils/RegExp'
import * as API_PAY from '@/api/pay'

export default {
  name: 'WeixinPay',
  props: ['currencyShort','currencyAct'],
  components: {
    Finish
  },
  data(){
    // 金额验证
    var validateMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_amount));
      } else if (!RegExp.money.test(value)) {
        callback(new Error(this.pc_lang.Please_enter_the_correct_amount));
      } else {
        callback();
      }
    };
    return {
      /*是否支付完成*/
      paySuccess: 0,
      /* 是否显示QrCode */
      qrShow: this.$route.query.tradeSerialNo == undefined ? 0 : 1,
      /* 充值金额 */
      weixinPayForm: {
        amount: ''
      },
      rulesForm: {
        amount: [
          { validator: validateMoney, trigger: 'blur' }
        ]
      },
      qrCodeUrl: '',
      out_trade_no: '',
      tradeRate: ''
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {
    if (this.$route.query.tradeSerialNo) {
      this.getQr()
      this.payTradeRate('RMB')
    }
  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getQr()
          this.payTradeRate('RMB')
        }else{
          return false
        }
      })
    },
    /* 获取支付表单 */
    getPayItem() {
      return new Promise((resolve, reject)=> {
        let params = {
          paymentPluginId: 'weixinPayPlugin',
          payMode: 'qr',
          clientType: 'PC',
          sn: this.$route.query.tradeSerialNo || new Date().getTime(),
          tradeType: this.$route.query.tradeSerialNo == undefined ? 'recharge' : 'order',
          amount: this.$route.query.tradeSerialNo == undefined ? this.weixinPayForm.amount : ''
        }
        API_PAY.getPayQrCode(params.tradeType, params.sn, params).then(res=> {
          resolve(res.data)
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 提交充值请求 */
    getQr() {
      this.qrShow = 1
      this.getPayItem().then(res=> {
        this.qrCodeUrl = res.gateway_url
        this.out_trade_no = res.out_trade_no
        this.whileWeixinPaySuccess()
      })
    },
    /* 请求是否支付完成 */
    whileWeixinPaySuccess() {
      let tradeType = this.$route.query.tradeSerialNo == undefined ? 'recharge' : 'order'
      API_PAY.whileWeixinPaySuccess(tradeType, this.out_trade_no).then(res=> {
        if (res.data.result == 'SUCCESS') {
          // this.paySuccess = 1
          window.open( res.data.url ,'_self')
        } else {
          if ( !!document.querySelector('.weixinQrWrap') ) {
            this.whileWeixinPaySuccess()
          }
        }
      },rej=> {
        this.whileWeixinPaySuccess()
      })
    },
    /* 转换币种金额 */
    payTradeRate(currencyShort) {
      return new Promise((resolve, reject)=> {
        let params = {
          amount: this.weixinPayForm.amount || 0,
          wayShort: 'weixin',
          tradeSerialNo: this.$route.query.tradeSerialNo,
          currencyShort
        }
        API_PAY.payTradeRateFee(params).then(res=> {
          this.tradeRate = res.data
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.qrWrap{
  h3{
    font-size: 16px;
    span{
      color: #f00;
      font-size: 32px;
      margin-left: 12px;
      abbr{
        font-size: 24px;
      }
    }
  }
}
.items{
  display: flex;
  align-items: center;
  .left{
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    >div.top{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 260px;
        height: 260px;
      }
    }
    >div.bottom{
      width: 300px;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $blue;
      color: #fff;
      p{
        font-size: 16px;
      }
      i{
        font-size: 38px;
        height: 38px;
        margin-right: 20px;
      }
    }
  }
  img{
    vertical-align: text-bottom;
  }
}
.weixinPayForm{
  .el-input,.el-select{
    width: 450px;
  }
  .el-form-item{
    margin-bottom: 14px;
  }
  .chooseAmount{
    line-height: 40px;
  }
  .huilv{
    width: 450px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      color: #999;
    }
  }
}

.huilvListWrap{
  .title{
    margin-bottom: 12px;
    span{
      font-size: 12px;
    }
  }
  td{
    padding: 5px 2px;
  }
}
</style>